import selectColorTypeVCard from "@/components/common/selectColorTypes";
export const InitialVCardData = {
  payload: {
    summary: "",
    name: "",
    welcome_screen: "",
    welcome_path: "",
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    company: "",
    job: "",
    street: "",
    street_number: "",
    state: "",
    country: "",
    website_url: "",
    design_colors_primary: selectColorTypeVCard[0].color,
    design_colors_button: selectColorTypeVCard[0].buttonColor,
    longitude: -73.9855426,
    latitude: 40.7579747,
    address: "",
    socialItems: [],
    button: "",
    description: "",
    website: "",
  },
};
